"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _themeUi = require("theme-ui");
var React = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("../../../../Layout/Box"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

/** @jsx jsx */
var ToggleIcon = function ToggleIcon(props) {
  return (0, _themeUi.jsx)(_Box.default, (0, _tslib.__assign)({}, props, {
    sx: {
      position: 'relative',
      width: '36px',
      height: '20px',
      borderRadius: '20px'
    },
    __css: {
      backgroundColor: 'gray',
      'input:checked ~ &': {
        backgroundColor: 'primary',
        '> span': {
          right: '3px',
          left: 'auto'
        }
      }
    }
  }), (0, _themeUi.jsx)(_Box.default, {
    as: "span",
    sx: {
      width: '14px',
      height: '14px',
      backgroundColor: 'white',
      borderRadius: '50%',
      display: 'block',
      position: 'absolute',
      top: '3px',
      left: '3px',
      right: 'auto'
    }
  }));
}; // TODO: Margin, padding bg, color being applied to wrong element (input instead of checkbox icon)

var ToggleBox = React.forwardRef(function (_a, ref) {
  var field = _a.field,
    sx = _a.sx,
    _b = _a.variant,
    variant = _b === void 0 ? 'forms.toggle' : _b,
    props = (0, _tslib.__rest)(_a, ["field", "sx", "variant"]);
  return (0, _themeUi.jsx)(_Box.default, null, (0, _themeUi.jsx)(_Box.default, (0, _tslib.__assign)({
    ref: ref,
    as: "input"
  }, props, field, {
    type: "checkbox",
    checked: field && field.value,
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: 1,
      width: '36px',
      height: '20px',
      overflow: 'hidden'
    }
  })), (0, _themeUi.jsx)(_Box.default, {
    as: ToggleIcon,
    "aria-hidden": "true",
    variant: variant,
    sx: sx,
    __css: {
      mr: 2,
      'input:checked ~ &': {
        color: 'primary'
      }
    }
  }));
});
var Toggle = function Toggle(_a) {
  var defaultChecked = _a.defaultChecked,
    field = _a.field,
    hint = _a.hint,
    id = _a.id,
    label = _a.label,
    name = _a.name,
    value = _a.value,
    props = (0, _tslib.__rest)(_a, ["defaultChecked", "field", "hint", "id", "label", "name", "value"]);
  return (0, _themeUi.jsx)(ToggleBox, (0, _tslib.__assign)({
    defaultChecked: defaultChecked,
    id: id,
    field: field,
    name: field && field.name || name,
    value: field && field.value || value || id
  }, props));
};
Toggle.displayName = 'Toggle';
Toggle.defaultProps = {
  defaultChecked: false
};
var _default = Toggle;
exports.default = _default;